<template>
  <div class="LuxinIntro lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto lxn-border-round">
    <div class="LanguageSelect-d0 lxn-w100">
      <CurveWithSvg>
      </CurveWithSvg>
    </div>

    <div class="LuxinIntro-wrapper-carousel lxn-w100 lxn-pos-rel">
      <carousel :perPage="1" :paginationEnabled="false" :navigateTo="navigateTo" :adjustableHeight="true" v-model="shownSlideNumber">
        <slide>
          <IntroSlide1 />
        </slide>
        <slide>
          <IntroSlide2 />
        </slide>
        <slide>
          <IntroSlide3 />
        </slide>
        <slide>
          <IntroSlide4 />
        </slide>
      </carousel>
    </div>

    <div class="LuxinIntro-wrapper-pagination lxn-w100">
      <div class="LuxinIntro-skipButton lxn-float-left">
        <CustomButton @click="handleNextButton" bgColor="#1EA5DE" textColor="#FFFFFF">
          {{nextButtonText}}
        </CustomButton>
      </div>
      <div class="LuxinIntro-slidePagination lxn-float-right">
        <SlidePagination @click="handleBulletClick" :slideCount="slideCount" :selectedSlide="shownSlideNumber" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Carousel, Slide } from 'vue-carousel';
import CurveWithSvg from '@/components/CurveWithSvg.vue'
import CustomButton from '@/components/CustomButton.vue'
import SlidePagination from '@/components/luxinIntro/SlidePagination.vue'
import IntroSlide1 from '@/components/luxinIntro/IntroSlide1.vue'
import IntroSlide2 from '@/components/luxinIntro/IntroSlide2.vue'
import IntroSlide3 from '@/components/luxinIntro/IntroSlide3.vue'
import IntroSlide4 from '@/components/luxinIntro/IntroSlide4.vue'



export default {
  name: 'LuxinIntro',
  components: {
    CurveWithSvg,
    CustomButton,
    Carousel,
    Slide,
    SlidePagination,
    IntroSlide1,
    IntroSlide2,
    IntroSlide3,
    IntroSlide4,
  },
  data: function() {
    return {
      slideCount: 4,
      shownSlideNumber: 0,
      navigateTo: 0,
    }
  },
  computed: {
    nextButtonText: function () {
      var returnValue = null;
      if(this.shownSlideNumber == this.slideCount - 1){
        returnValue = this.$store.getters.language.texts.LuxinIntro_Finish;
      }else{
        returnValue = this.$store.getters.language.texts.LuxinIntro_Next;
      }
      return returnValue;
    }
  },
  methods: {
    handlePageChange: function () {
      // console.log(slideNumber)
    },
    handleBulletClick: function (bulletIndex) {
      this.navigateTo = [bulletIndex, false];
    },
    handleNextButton: function () {
      if(this.shownSlideNumber != this.slideCount - 1){
        this.shownSlideNumber++;
      }else{
        this.$store.commit('setIsIntroTaken', true);
        this.$store.commit('saveState');
        //.catch is added because push('/') is redirected to some other page and as far as 'push' knows, it is failed.
        this.$router.push('/').catch(function(){});
      }
    },
  }
}
</script>

<style>
  .LuxinIntro {
    background-color: #ffffff;
    padding: 18px;
    padding-top: 0;
  }
  .LanguageSelect-d0 {
    height: 40vh;
  }
  .LuxinIntro-wrapper-carousel {
    margin-top: -40vh;
    z-index: 3;
    min-height: 500px;
  }
  .LuxinIntro-wrapper-pagination {
    margin-top: 20px;
    overflow: auto;
  }
  .LuxinIntro-skipButton {
    width: 100px;
  }
  .LuxinIntro-slidePagination {
    width: calc(100% - 100px - 18px);
    height: 14px;
    margin-top: 18px;
  }
  /* fix for firefox carousel problem */
  .VueCarousel-slide-adjustableHeight {
    display: block !important;
  }
  .VueCarousel-inner {
    align-items: flex-start !important;
  }
</style>
